export var SCREENING_TYPE = 'screening';
export var SCREENING_TEXT = 'External Screening';
export var PLACEHOLDER_CHAR = '-';
export var COMMUNICATION_SMS = 'sms';
export var COMMUNICATION_EMAIL = 'email';
export var COMMUNICATION_PRINT = 'print';
export var MANUAL_SENDBACK = 'manual_share_to_emr';
export var AUTOMATIC_SENDBACK = 'automatic_share_to_emr';
export var CLIENTS = {
  WEB_APP: 'web_app',
  SMART_APP: 'smart_app'
};
export var NOTIFICATION_ERROR = 'There was an error with your request. Please try again later.';
//# sourceMappingURL=constants.js.map